export default __webpack_public_path__ + "static/media/react.0ff3f121.png";